<template>
  <div class="pb-12 text-gray-800 font-arial bg-bc-gray pt-7">
    <h2 class="text-[17px] font-bold text-center uppercase mb-4 tracking-[3px]">
      {{ organism.title1 }}
    </h2>
    <ul
      class="flex flex-wrap items-center mx-auto justify-evenly max-w-7xl gap-10"
    >
      <li class="flex gap-5" v-for="feature in organism.item">
        <img
          class="w-[104px] h-[104px] aspect-square object-cover rounded-full"
          :src="feature?.image?.sizes?.thumbnail"
          :alt="feature?.image?.alt"
        />
        <div class="max-w-[230px] flex justify-center flex-col">
          <h3
            class="text-lg font-bold uppercase text-bc-dark-blue leading-none mb-[5px]"
          >
            {{ feature?.title_1 }}
          </h3>
          <p class="text-lg leading-6">{{ feature?.text_1 }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  organism: Object,
});
</script>
